@if (!stitchItem) {
  <app-no-content-stub
    class="min-h-0 flex-1 text-base font-medium text-gray-900"
    imageSrc="assets/placeholders/placeholder-knowledge-markers.svg"
  >
    <p class="text-base font-medium text-gray-900 text-center">Select an item to see related Connections</p>
  </app-no-content-stub>
}

<div
  data-test="kp-related-box"
  class="relative min-h-0 flex-1 items-start gap-4 overflow-hidden rounded bg-primary-50 px-4 py-5"
  [class.flex]="!!stitchItem"
  [class.hidden]="!stitchItem"
>
  <!-- The list scrolls, so it takes focus: a keyboard cannot scroll a region it cannot reach (axe: scrollable-region-focusable). -->
  <div
    class="flex min-h-0 min-w-0 flex-1 flex-col self-stretch overflow-y-auto"
    tabindex="0"
    role="region"
    aria-label="Related Connections"
  >
    <!-- An empty box drops its "Related Connections:" label: the empty state below names it, centred (Johanna). -->
    @if (!(stitchItem && neighborsConnections.length === 0 && !loading)) {
    <div class="flex flex-wrap items-center gap-2">
      <span class="whitespace-nowrap text-sm font-semibold text-gray-800">Related Connections:</span>

      @if (stitchItem && neighborsConnections.length) {
        @for (connection of neighborsConnections | slice: 0 : (page + 1) * perPage; track connection) {
          <app-connection
            class="min-w-0"
            [connection]="connection"
            [withControls]="false"
            [dragEnabled]="false"
            [dropEnabled]="false"
            (click)="handleClickItem(connection)"
          />
        }
        <!-- stitch-app-shell skin (`RelatedBox`): "+N more" and "Show less" are small Gray/100 pills. -->
        @if (page < pagesCount - 1) {
          <button type="button" class="kp-related-more" (click)="showMore()">+{{ remaining }} more</button>
        }
        @if (page !== 0) {
          <button type="button" class="kp-related-more" (click)="showLess()">Show less</button>
        }
      }
    </div>
    }

    @if (stitchItem && neighborsConnections.length === 0) {
      @if (loading) {
        <app-loading-indicator [inPanel]="true">Surfacing related connections...</app-loading-indicator>
      } @else {
        <!-- The empty state of the other pages, centred on the whole box (not beside the filter button, which stays on
             top and clickable) with the same 56px-tall art as the panel's idle empty state below (Johanna, 2026-10-21).
             It is laid over the box, so it never makes the list scroll; the label row hides while it shows. When the bottom
             panel is dragged up and the box gets shorter than its content, it stays at the top ("safe center") and the box
             clips it with the filter, so nothing spills over the panel's tabs or the results below. -->
        <div
          class="pointer-events-none absolute inset-x-0 top-0 flex min-h-full flex-col items-center gap-[8px] [justify-content:safe_center]"
          data-test="kp-related-empty"
        >
          <img class="h-[56px] w-auto shrink-0" src="assets/placeholders/knowledge-doodle.svg" alt="" />
          <p class="text-base font-medium leading-[16px] text-gray-900 text-center">No related Connections</p>
        </div>
      }
    }
  </div>

  <app-context-menu-state-indicator
    class="relative z-[1] h-8 shrink-0 [--state-indicator-icon-color:var(--color-gray-500)]"
    svgIcon="filters"
    [appConnectionsManageContextMenu]="true"
    [appConnectionsManageContextMenuNeighbours]="true"
    [appConnectionsManageContextMenuStateKey]="StateKey.kpConnectionsState"
    [appConnectionsManageContextMenuDefaultState]="defaultFiltersState"
    (appConnectionsManageContextMenuStateChange)="setState($event)"
  />
</div>
